import { notFound } from "next/navigation";

import {
  getBlocks,
  getHeadingAnchorId,
  getHeadings,
  getNodes,
  mapToDatoLocale,
} from "@trip/cms/utils";
import { SUPPORTED_LOCALES, type SiteLocale } from "@trip/constants";

// Re-export utilities from CMS package
export { getBlocks, getHeadingAnchorId, getHeadings, getNodes };

export function getDatoLocale(locale: string) {
  if (isSupportedLocale(locale)) {
    return mapToDatoLocale(locale);
  }
  notFound();
}

function isSupportedLocale(locale: string): locale is SiteLocale {
  return SUPPORTED_LOCALES.includes(locale as SiteLocale);
}
